import classNames from 'classnames'
import React from 'react'
import { Text } from '@pandiafi/components'

export interface SidebarInfoSectionTextProps {
  children: React.ReactNode
  className?: string
}

export const SidebarInfoSectionText: React.FC<SidebarInfoSectionTextProps> = ({
  children,
  className,
}) => {
  return (
    <Text
      element="p"
      className={classNames(
        'whitespace-pre-line text-common-gray-7',
        className
      )}
      size="l"
      weight="medium"
    >
      {children}
    </Text>
  )
}
